import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  AgrExtendedNotificationModule,
  AgrFilterModule,
  AgrLogoWideModule,
  AgrNotificationEmptyModule,
  AgrPageDetailModule,
  AgrPrintPageModule,
  AgrSummaryCardHorizontalModule,
  AgrSummaryCardModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { SettingsService } from '@next/core-lib/settings';
import { AgrTableModule } from '@next/core-lib/table';
import { TableV2Module } from '@next/core-lib/table-v2';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { FlockMultilineChartModule } from '../shared/components/flock-multiline-chart/flock-multiline-chart.module';
import { FlockDataSeriesService } from '../shared/services/flock-dataseries-service';
import { SharedModule } from '../shared/shared.module';
import { AnimalCountReportComponent } from './components/animal-count-report/animal-count-report.component';
import { AdvancedSettingComponent } from './components/arrival-detail/advanced-setting.component';
import { ArrivalDetailComponent } from './components/arrival-detail/arrival-detail.component';
import { BreederFlockOverviewComponent } from './components/breeders/flock-overview/breeder-flock-overview.component';
import { BreederFlockOverviewWeekKpiChartComponent } from './components/breeders/flock-overview-week-kpi-chart/breeder-flock-overview-week-kpi-chart.component';
import { BreederFlockOverviewWeekRegistrationItemComponent } from './components/breeders/flock-overview-week-registration-item';
import { DepartureDetailComponent } from './components/departure-detail/departure-detail.component';
import { CarbonFootprintComponent } from './components/emission/carbon-footprint/carbon-footprint.component';
import { FarmResourcesComponent } from './components/emission/farm-resources/farm-resources.component';
import { ResourceEditComponent } from './components/emission/resource-edit/resource-edit.component';
import { FeedBalanceActionComponent } from './components/feed-balance/feed-balance-action.component';
import { FlockOverviewPanelComponent } from './components/flock-overview-panel/flock-overview-panel.component';
import { FlockOverviewWeekChartSettingsComponent } from './components/flock-overview-week-chart-settings/flock-overview-week-chart-settings.component';
import { FlockOverviewWeekKpiChartComponent } from './components/flock-overview-week-kpi-chart/flock-overview-week-kpi-chart.component';
import { FlockOverviewWeekRegistrationComponent } from './components/flock-overview-week-registration/flock-overview-week-registration.component';
import { FlockOverviewWeekRegistrationDetailedComponent } from './components/flock-overview-week-registration-detailed';
import { FlockOverviewWeekRegistrationDetailedWrapper } from './components/flock-overview-week-registration-detailed-wrapper';
import { FlockOverviewWeekRegistrationItemComponent } from './components/flock-overview-week-registration-item/flock-overview-week-registration-item.component';
import { FlockReportComponent } from './components/flock-report/flock-report.component';
import { ImportComponent } from './components/import/import.component';
import { LayerFlockOverviewComponent } from './components/layers/flock-overview/layer-flock-overview.component';
import { SharedFlockOverviewComponent } from './components/shared/flock-overview/shared-flock-overview.component';
import { FlockOverviewWeekRegistrationCardComponent } from './components/shared/flock-overview-week-registration-card';
import { WeekRegistrationFormComponent } from './components/week-registration/week-registration-form.component';
import { WeekRegistrationComponent } from './components/week-registration/week-registration.component';
import { FlockComponent } from './flock.component';
import { AnimalCountCardsResolver } from './resolvers/animalcount.resolver';
import { FlockWeekregistrationKpiService } from './services/flock-weekregistration-kpi.service';
import { FlockService } from './services/flock.service';
import { FlockEffects } from './store/effects/flock.effects';
import * as flockReducer from './store/reducers/flock.reducer';

@NgModule({
  declarations: [
    FlockComponent,
    LayerFlockOverviewComponent,
    BreederFlockOverviewComponent,
    SharedFlockOverviewComponent,
    FlockOverviewPanelComponent,
    FlockOverviewWeekRegistrationComponent,
    FlockOverviewWeekRegistrationItemComponent,
    WeekRegistrationComponent,
    WeekRegistrationFormComponent,
    ImportComponent,
    ArrivalDetailComponent,
    DepartureDetailComponent,
    FlockReportComponent,
    AnimalCountReportComponent,
    AdvancedSettingComponent,
    FlockOverviewWeekKpiChartComponent,
    BreederFlockOverviewWeekKpiChartComponent,
    FlockOverviewWeekChartSettingsComponent,
    FarmResourcesComponent,
    ResourceEditComponent,
    CarbonFootprintComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FeedBalanceActionComponent,
    BreederFlockOverviewWeekRegistrationItemComponent,
    FlockOverviewWeekRegistrationDetailedComponent,
    FlockOverviewWeekRegistrationDetailedWrapper,
    FlockOverviewWeekRegistrationCardComponent,
    AgrFormModule,
    AgrPageDetailModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatToolbarModule,
    MatSelectModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    AgrDialogModule,
    AgrNotificationEmptyModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatDatepickerModule,
    AgrPrintPageModule,
    AgrValueRowModule,
    AgrLogoWideModule,
    RouterModule,
    MatMenuModule,
    FlockMultilineChartModule,
    AgrSummaryCardHorizontalModule,
    AgrSummaryCardModule,
    AgrExtendedNotificationModule,
    AgrFilterModule,
    AgrTableModule,
    TableV2Module,
    MatSortModule,
    MatTooltipModule,
  ],
  providers: [
    FlockService,
    FlockWeekregistrationKpiService,
    FlockDataSeriesService,
    DatePipe,
    SettingsService,
    AnimalCountCardsResolver,
    provideState('flockModule', flockReducer.reducer),
    provideEffects([FlockEffects]),
  ],
})
export class FlockModule {}
